import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';

export function getRentalStatusMessage(status: string, displayTime?: string) {
  if(!status) return 'Confirmed: Status Unknown';

  switch (status) {
    case 'CANCELLED':
      return 'Confirmed: Your rental has been cancelled';

    case "COMPLETED":
    case "RETURNED":
    case "LATE_RENTAL":
    case "POSSIBLE_LATE_RENTAL":
        return 'Confirmed: Your rental has ended';

    case "LATE_PICKUP":
    case "POSSIBLE_LATE_PICKUP":
    case "ON_RENTAL":
        return 'Confirmed: Your rental has been started';

    case 'UPCOMMING_RENTAL':
      return displayTime
        ? `Confirmed: Your pickup is ${displayTime} away`
        : 'Confirmed: Your rental is starting soon';

    default:
      return 'Confirmed: Status Unknown';
  }
}

export function getBookingIconColor(status: string) {
  if(!status) return 'lightGreen';

  switch (status) {
    case 'CANCELLED':
      return 'beanRed';

    case 'UPCOMMING_RENTAL':
      return 'lightGreen';

    default:
	  return 'disabledGray';
  }
}

export function getUploadIcon(complete: boolean, status: string) {
  if(complete && (!status || status === 'UPCOMMING_RENTAL'))
  	return (
		<CheckCircleFilled className="text-lightGreen mr-8" style={{ fontSize: 24 }} />
		);
   if(complete && (status !== 'UPCOMMING_RENTAL'))
  	return (
		<div className="w-[24px] h-[24px] bg-disabledGray rounded-full mr-8" />
		);

  if(!complete && (!status || status !== 'UPCOMMING_RENTAL'))
  	return (<CloseOutlined
          className="text-beanRed mr-8"
          style={{ fontSize: 24 }}
        />);
}
